import { PERIODS } from 'components/PeriodPicker/periods/constants';
import {
  ON_CHANGE_FILTERS_BAR_HEIGHT,
  ON_CHANGE_FILTERS,
  ON_CHANGE_LOCAL_FILTERS,
  ON_CLEAR_FILTER_SET,
  ON_CREATE_FILTER_SET,
  ON_DELETE_FILTER_SET,
  ON_INIT_FILTERS,
  ON_SELECT_FILTER_SET,
  ON_SELECT_PERIOD,
  ON_UPDATE_FILTER_SET,
  ON_UPDATE_FILTERS_PAYLOAD,
  RESET,
  SET_UI_REF,
  SET_IS_LOADING
} from './actions';
import { omit } from 'lodash';
import { FILTERS_PROVIDER_UI_REFS } from './consts';

export const generateInitialState = () => {
  return {
    period: PERIODS.PAST_6_MONTHS,
    isInitialized: false,
    isLoading: false,
    filters: {},
    localFilters: {},
    filtersPayload: {},
    pdtEntities: [],
    filterSets: {},
    selectedFilterSetId: null,
    filtersBarHeight: 0,
    uiRefs: {
      [FILTERS_PROVIDER_UI_REFS.TRIGGER_FILTER_MENUS_BUTTON]: null
    }
  };
};

const reducer = (state, action) => {
  switch (action.type) {
    case RESET:
      return { ...state, isInitialized: false };

    case SET_IS_LOADING:
      return { ...state, isLoading: action.payload };

    case ON_INIT_FILTERS:
      return {
        ...state,
        period: action.payload.period,
        setPeriod: action.payload.setPeriod,
        isInitialized: true,
        filters: action.payload.filters,
        localFilters: action.payload.filters,
        pdtEntities: action.payload.pdtEntities,
        filterSets: action.payload.filterSets,
        selectedFilterSetId: action.payload.selectedFilterSetId,
        filtersBarHeight: action.payload.filtersBarHeight,
        extraPayload: action.payload.extraPayload
      };

    case ON_SELECT_FILTER_SET:
      return {
        ...state,
        selectedFilterSetId: action.payload.filterSetId,
        filters: action.payload.filters
      };

    case ON_CHANGE_FILTERS_BAR_HEIGHT:
      return {
        ...state,
        filtersBarHeight: action.payload
      };

    case ON_CLEAR_FILTER_SET:
      return {
        ...state,
        selectedFilterSetId: null,
        filters: {}
      };

    case ON_CREATE_FILTER_SET:
      const newFilterSet = action.payload;
      return {
        ...state,
        filterSets: {
          ...state.filterSets,
          [newFilterSet.id]: newFilterSet
        },
        filters: newFilterSet.filters,
        selectedFilterSetId: newFilterSet.id
      };

    case ON_UPDATE_FILTER_SET:
      const updatedFilterSet = action.payload;
      return {
        ...state,
        filterSets: {
          ...state.filterSets,
          [updatedFilterSet.id]: updatedFilterSet
        },
        filters: updatedFilterSet.filters
      };

    case ON_DELETE_FILTER_SET:
      const deletedFilterSetId = action.payload;
      return {
        ...state,
        filterSets: omit(state.filterSets, [deletedFilterSetId]),
        ...(state.selectedFilterSetId === deletedFilterSetId && {
          selectedFilterSetId: null
        })
      };

    case ON_CHANGE_FILTERS:
      return {
        ...state,
        filters: action.payload
      };

    case ON_CHANGE_LOCAL_FILTERS:
      return {
        ...state,
        localFilters: action.payload
      };

    case ON_UPDATE_FILTERS_PAYLOAD:
      return {
        ...state,
        filtersPayload: action.payload
      };

    case ON_SELECT_PERIOD:
      return {
        ...state,
        period: action.payload
      };

    case SET_UI_REF:
      return {
        ...state,
        uiRefs: {
          ...state.uiRefs,
          [action.payload.uiRefKey]: action.payload.ref
        }
      };

    default:
      return state;
  }
};

export default reducer;
